import constants from "./constants";
import { isDriverReadyForDispatch } from "../utils/index";
const getTrailerError = (trailer, trailersData) => {
  let error = "";
  if (!trailer?.trailerNumber) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if (!constants.TRAILER_VALID_STATUS.includes(trailer?.trailerStatus)) {
    error = constants.ERROR_MESSAGES.VALID_TRAILER_STATUS;
  } else if (
    trailersData.filter((t) => trailer.trailerNumber === t.trailerNumber).length > 1
  ) {
    error = constants.ERROR_MESSAGES.DUPLICATE_TRAILER;
  }
  return error;
};

const getDollyError = (dolly, trailersData) => {
  let error = "";
  if (!dolly) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if (!constants.DOLLY_VALID_STATUS.includes(dolly?.dollyStatus)) {
    error = constants.ERROR_MESSAGES.VALID_DOLLY_STATUS;
  } else if (
    trailersData.filter(
      (t) =>
        t.dolly?.value === dolly.value && dolly.label !== constants.ADHOC_DOLLY
    ).length > 1
  ) {
    error = constants.ERROR_MESSAGES.DUPLICATE_DOLLY;
  }
  return error;
};

const getTractorError = (tractor) => {
  let error = null;
  // no validations required if straight truck
  if (tractor && tractor.isStraightTruck){
    return error
  }

  if (!tractor) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  }else if (!constants.TRACTOR_VALID_STATUS.includes(tractor.tractorStatus)) {
    error = constants.ERROR_MESSAGES.VALID_TRACTOR_STATUS;
  }
  return error;
};

const isStraightTruck = (trailerType) => {
  return Boolean(constants.STRAIGHT_TRUCK.includes(trailerType?.toUpperCase()));
}

const getDriverError = (driverData) => {
  let error = "";
  if (!driverData) {
    error = constants.ERROR_MESSAGES.REQUIRED;
  } else if (driverData.as400Status !== "AVL") {
    error = constants.ERROR_MESSAGES.VALID_DRIVER_STATUS;
  } else if (
    !isDriverReadyForDispatch(driverData.clockedInTime, driverData.isCompanyDriver)
  ) {
    error = constants.ERROR_MESSAGES.DRIVER_CLOCKED_IN_STATUS;
  }
  return error;
};
const getUpdatedTrailerError = (trailerDetails, trailerDetailsErrors) => {
  return trailerDetails.map((trailer, index) => {
    let trailerError = getTrailerError(trailer, trailerDetails);
    let dollyError = getDollyError(trailer.dolly, trailerDetails);
    if (
      trailerDetailsErrors[index]?.trailerNumber !== trailerError &&
      [constants.ERROR_MESSAGES.REQUIRED].includes(trailerError)
      ) {
      trailerError = trailerDetailsErrors[index]?.trailerNumber;
    }
    if (
      index !==0 && trailerDetailsErrors[index]?.dolly !== dollyError &&
      [constants.ERROR_MESSAGES.REQUIRED].includes(dollyError)
    ) {
      dollyError = trailerDetailsErrors[index]?.dolly;
    }
    return {
      trailerNumber: trailerError,
      dolly: dollyError,
    };
  });
};


export {
  getTrailerError,
  getTractorError,
  getDollyError,
  isStraightTruck,
  getDriverError,
  getUpdatedTrailerError
};
